import { UpdateRoleCredentials } from '../editRole/updateRoleCredentials';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { useHasPermission } from '../../../hooks/useHasPermission';
import { Box, Typography, Tooltip, Chip } from '@mui/material';
import { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Iconify from '../../Iconify';
import axios from 'axios';
import '../../../css/roles/readRoleCredentials.css';

const ReadRoleCredentials = () => {

    const { t } = useTranslation();
    const hasMachineUpdatePermission = useHasPermission('role_update');
    const roleDetailsData = useSelector((state) => state.RoleDetailsData);

    const [allCredentials, setAllCredentials] = useState([]);
    const [updateRoleCredentials, setUpdateRoleCredentials] = useState(false);

    useEffect(() => {
        const fetchCredentials = async () => {
            try {
                const response = await axios.get('credential');
                if (response.status === 200 || response.status === 201) {
                    setAllCredentials(response.data);
                }
            } catch (error) {
                console.error('Error fetching credentials:', error);
                CustomErrorLogger(error, 'Error fetching credentials in ReadRoleCredentials');
            }
        };

        fetchCredentials();
    }, []);

    // Group credentials by their group name and check if they are selected
    const groupedCredentials = useMemo(() => {
        const groups = {};
        allCredentials.forEach((credentialGrp) => {
            const groupName = credentialGrp.groupName || 'Other';
            if (!groups[groupName]) {
                groups[groupName] = [];
            }
            credentialGrp.credentials.forEach((credential) => {
                groups[groupName].push({
                    ...credential,
                    isSelected: roleDetailsData?.role_credential?.some(
                        (selected) => selected.id === credential.id
                    ),
                });
            });
        });
        return groups;
    }, [allCredentials, roleDetailsData]);

    // Render grouped credentials with titles instead of Accordion
    const credentialsList = useMemo(() => {
        return Object.entries(groupedCredentials).map(([groupName, credentials], index) => (
            <Box key={index} sx={{ marginBottom: '20px' }}>
                {/* Group Title */}
                <Typography variant="h6" component="div" sx={{ marginBottom: '10px', fontWeight: 'bold', fontFamily: 'Mulish' }}>
                    {groupName}
                </Typography>
                {/* Grouped Chips */}
                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                    {credentials.map((credential) => (
                        <Tooltip
                            key={credential.id}
                            title={credential.description}
                            arrow
                            componentsProps={{
                                tooltip: {
                                    sx: {
                                        backgroundColor: '#EE792B',
                                    },
                                },
                                arrow: {
                                    sx: {
                                        color: '#EE792B',
                                    },
                                },
                            }}
                        >
                            <Chip
                                label={credential.name}
                                sx={{
                                    backgroundColor: roleDetailsData?.role_credential?.some(
                                        (selected) => selected.credential.id === credential.id
                                    )
                                        ? '#EA5E00'
                                        : '#e0e0e0',
                                    color: roleDetailsData?.role_credential?.some(
                                        (selected) => selected.credential.id === credential.id
                                    )
                                        ? '#fff'
                                        : '#000',
                                }}
                            />
                        </Tooltip>
                    ))}
                </Box>
            </Box>
        ));
    }, [groupedCredentials, roleDetailsData?.role_credential]);

    return (
        <Box className='readRoleCredentials_box'>
            <Box className='readRoleCredentials_edit_box'>
                <Typography className='readRoleCredentials_title'>{t('Les autorisations du rôle')}</Typography>
                {hasMachineUpdatePermission && <Iconify className='readRoleCredentials_edit_icon' icon={"ic:outline-edit"} onClick={() => setUpdateRoleCredentials(true)} />}
            </Box>
            <Box className='readRoleCredentials_credentials_box'>
                {credentialsList}
            </Box>
            {updateRoleCredentials &&
                <UpdateRoleCredentials
                    updateRoleCredentials={updateRoleCredentials}
                    setUpdateRoleCredentials={setUpdateRoleCredentials}
                />
            }
        </Box>
    );
};

export default ReadRoleCredentials;